import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ObrasService } from "../../../services/obras.service";
import { CuentasService } from "../../../services/cuentas.service";

@Component({
  selector: "app-modal-ingreso-interno",
  templateUrl: "./modal-ingreso-interno.component.html",
  styleUrls: ["./modal-ingreso-interno.component.scss"],
})
export class ModalIngresoInterno {
  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  @ViewChild("content") private content: TemplateRef<any>;

  public modal: any = null;

  public obraSeleccionada: any = null;
  public cuentaSeleccionada: any = null;

  public loading: boolean = true;
  public loading_obras: boolean = false;
  public loading_cuentas: boolean = false;
  public obras: any[] = [];
  public cuentas: any[] = [];

  errors: any = {};

  constructor(
    private router: Router,
    private obrasService: ObrasService,
    private cuentasService: CuentasService,
    private modalService: NgbModal
  ) {}

  public openModal() {
    this.loadObras();
    this.modal = this.modalService.open(this.content, { size: "lg" });
  }

  public closeModal() {
    this.onCancel.emit();
    this.reset();
    this.modal.close();
  }

  public isObraSeleccionada() {
    return this.obraSeleccionada && this.obraSeleccionada.idObras !== null;
  }

  public isCuentaSeleccionada() {
    return (
      this.cuentaSeleccionada && this.cuentaSeleccionada.idCuentas !== null
    );
  }

  private loadObras() {
    this.loading_obras = true;
    this.obrasService.getObratoSelect('/movimientos').subscribe(
      (response) => {
        let content = response.json().content;
        this.obras = content;
        this.loading_obras = false;
      },
      (error) => {
        alert("ERROR: " + JSON.stringify(error));
        this.loading_obras = false;
      }
    );
  }

  private loadCuentas() {
    this.loading_cuentas = true;
    this.cuentasService
      .getCuentasByObraToSelectSobre(this.obraSeleccionada.idObras)
      .subscribe(
        (response) => {
          let content = response.json().content;
          this.cuentas = content;
          this.loading_cuentas = false;
        },
        (error) => {
          alert("ERROR: " + JSON.stringify(error));
          this.loading_cuentas = false;
        }
      );
  }

  public changeObra(event) {
    this.obraSeleccionada = event;
    this.cuentaSeleccionada = null;
    this.loadCuentas();
  }

  public guardar() {
    this.onSubmit.emit({
      obraIngresoInterno: this.obraSeleccionada,
      cuentaIngresoInterno: this.cuentaSeleccionada,
    });
    this.modal.close();
  }

  public reset() {
    this.obraSeleccionada = null;
    this.cuentaSeleccionada = null;
    this.errors = {};
  }
}



// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/modal-ingreso-interno/modal-ingreso-interno.component.ts